export enum AuthMechanism {
  ApiKeyPlain = 'API_KEY_PLAIN',
  PasswordPlain = 'PASSWORD_PLAIN',
  TokenPlain = 'TOKEN_PLAIN',
  OtpToken = 'OTP_TOKEN',
}
